<template>
  <div class="flex flex-col items-start gap-7 self-stretch">
    <ProductPreview v-if="store.payment?.paymentType === 'product'"></ProductPreview>
    <BumpPreview
      v-if="store.payment?.paymentType === 'product' && store.payment.bumpSettings.enableBump"
    ></BumpPreview>
    <div class="flex flex-col items-start gap-8 self-stretch">
      <DonationPreview
        v-if="store.payment.paymentType !== 'product'"
        :payment="payment"
        :input-class="inputClass"
      ></DonationPreview>
      <CouponPreview
        v-if="store.payment.paymentType === 'product' && store.payment?.coupon?.enableCoupon"
      ></CouponPreview>
      <UIAlert
        v-if="store.payment.showInfoAboutPayment"
        id="warning-message"
        type="default"
        :closable="false"
      >
        <template #content
          >Payment will be processed as soon as you proceed to the next step</template
        >
      </UIAlert>
      <PaymentCardPreview></PaymentCardPreview>
    </div>
    <div v-if="!store.payment.footer.hidden" class="self-stretch text-center text-xs text-gray-400">
      <div
        ref="footerMessageElement"
        contenteditable="true"
        class="w-full cursor-text border-0 text-center text-xs text-gray-400 outline-none focus:outline-none"
        @blur="store.addToHistory"
        @input="(e) => {
          store.payment.footer.message = (e.target as HTMLElement).textContent;
          handleSafariCursor(e);
        }"
        @keydown="handleSafariCursor"
        @click="(e) => e.stopPropagation()"
        @focus="(e) => e.stopPropagation()"
        v-text="t(store.payment.footer.message)"
      ></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useAppStore } from "@/store/app";
import { fixSafariCursor } from "@/util/methods";
import { UIAlert } from "@gohighlevel/ghl-ui";
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import DonationPreview from "../Donation/DonationPreview.vue";
import BumpPreview from "../Products/bump/bumpPreview.vue";
import ProductPreview from "../Products/ProductPreview.vue";
import CouponPreview from "./CouponPreview.vue";
import PaymentCardPreview from "./PaymentCardPreview.vue";
const { t } = useI18n();
const store = useAppStore();
const footerMessageElement = ref<HTMLElement | null>(null);

defineProps({
  payment: {
    type: Object,
    default: () => {
      return {};
    },
  },
  inputClass: {
    type: Array,
    default: () => {
      return [];
    },
  },
});

const handleSafariCursor = (e: Event) => {
  const isKeyDown = e.type === "keydown";
  fixSafariCursor(e, isKeyDown);
};
</script>
